import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { get } from 'lodash';
import { RootState } from 'modules';
import moment from 'moment';
import InterviewDetail from 'components/community/parts/interviewDetail/interviewDetail';
import ShareLinkMenu from 'components/community/parts/ShareLinkMenu';
import apiClient, { makeQueryString, WrappingApiClient } from 'libs/api/apiClient';
import { CWindowWidth } from 'constants/base.const';
import { CCSLogoImageUrl } from 'constants/base.const';
import { CEmploymentType } from 'constants/community.const';
import { ERoute } from 'enums/route.enum';
import { Button } from 'antd';
import styled from 'styled-components';
import { PrimaryColor, device, SecondaryColor } from 'GlobalStyles';
import avatarIcon from 'assets/icons/avatar.webp';
import defaultCompanyImg from 'assets/images/pages/community/defaultCompany.webp';
import integratedCompanyImg from 'assets/images/pages/community/integratedCompany.webp';
import blurPage from 'assets/images/pages/community/unLoginPage.webp';

const FinalAcceptanceDetail = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [finalDetail, setFinalDetail] = useState({
    company: {
      company_name: '',
      company_logo_url: '',
    },
    employment_type: '',
    interview_date: '',
    education: {
      id: '',
      university_name: '',
      university_logo_url: '',
    },
    major: '',
    gpa: '',
    gpa_type: '',
    num_of_intern: 0,
    num_of_career: 0,
    pass_tip: '',
    case_study: '',
    experience_for_career: '',
    interview_review_tip: [],
    interview_review: [],
  });
  const { id }: any = useParams();
  const interviewYear = moment(get(finalDetail, 'interview_date')).format('YYYY');
  const interviewMonth = moment(get(finalDetail, 'interview_date')).format('M');

  const apiCallFinalAcceptanceList = (id: string) => {
    return WrappingApiClient(apiClient.get(`/community/final_review/${id}`));
  };

  const getFinalAcceptanceDetail = async () => {
    const { success, data } = await apiCallFinalAcceptanceList(id);

    if (success) setFinalDetail(data);
  };

  const kakaoSharingCompanyName = (companyName: string) => {
    if (companyName === 'McKinsey' || companyName === 'BCG' || companyName === 'Bain & Company') {
      return 'Mckinsey‧BCG‧Bain';
    } else {
      return companyName;
    }
  };

  useEffect(() => {
    getFinalAcceptanceDetail();
  }, [id]);

  return (
    <StyledContainer>
      <StyledHeader>
        <div className='title'>최종합격 후기</div>
        <div className='btns'>
          <Link to={'/community/final_acceptance'}>
            <Button>목록보기</Button>
          </Link>
          <Link to={'/community/final_acceptance/write'}>
            <Button type='primary'>최종합격 후기 등록</Button>
          </Link>
        </div>
      </StyledHeader>

      <StyledInfoCard>
        <img
          src={
            finalDetail.company.company_name === 'McKinsey' ||
            finalDetail.company.company_name === 'BCG' ||
            finalDetail.company.company_name === 'Bain & Company' ||
            finalDetail.company.company_name === 'McKinsey-Bain-Company'
              ? integratedCompanyImg
              : finalDetail.company.company_logo_url
              ? finalDetail.company.company_logo_url
              : defaultCompanyImg
          }
          alt='company_logo'
          className='img'
        />
        <StyledInfos>
          <div className='infoHeader'>
            <div>
              <h2 className='company'>
                {finalDetail.company.company_name === 'McKinsey' ||
                finalDetail.company.company_name === 'BCG' ||
                finalDetail.company.company_name === 'Bain & Company' ||
                finalDetail.company.company_name === 'McKinsey-Bain-Company' ||
                finalDetail.company.company_name === 'McKinsey\u00b7BCG\u00b7Bain' ? (
                  <span>McKinsey&middot;BCG&middot;Bain</span>
                ) : (
                  finalDetail.company.company_name
                )}
              </h2>
              <div className='subtitles'>
                <h3 className='employmentType'>
                  {finalDetail.employment_type === 'newcomer'
                    ? '신입'
                    : finalDetail.employment_type === 'experienced_worker'
                    ? '경력'
                    : finalDetail.employment_type === 'general_type_intern'
                    ? '인턴'
                    : '전환형 인턴'}
                </h3>
                <h3 className='employmentDate'>{`${finalDetail.interview_date.split('-')[0]}년 ${
                  finalDetail.interview_date.split('-')[1]
                }월`}</h3>
              </div>
            </div>
            <div>
              <ShareLinkMenu
                title={`${kakaoSharingCompanyName(
                  finalDetail.company.company_name,
                )} - ${interviewYear}년 ${interviewMonth}월 ${CEmploymentType[finalDetail.employment_type]}`}
                description={`최종합격후기`}
                // imageUrl={finalDetail.company.company_logo_url}
                imageUrl={CCSLogoImageUrl}
                pageUrl={window.location.href}
                btnTitle='자세히보기'
              />
            </div>
          </div>

          <StyledDetailInfo>
            <div className='avatar'>
              <img className='avatarIcon' src={avatarIcon} alt='avatar' />
              <div className='avatarText'>합격자 스펙</div>
            </div>

            <div
              className='divider'
              style={{ margin: '0 40px', width: '1px', height: '64px', border: '1px solid white' }}
            />

            <div className='infosBox'>
              <div className='schoolLogo' style={{ width: '43px', height: '43px' }}>
                <img src={finalDetail.education.university_logo_url} alt='' style={{ width: '100%' }} />
              </div>
              <div className='infos first'>
                <div className='info'>
                  <div className='label'>학교명</div>
                  <div className='content'>{finalDetail.education.university_name}</div>
                </div>
                <div className='info'>
                  <div className='label'>전공</div>
                  <div className='content'>{finalDetail.major}</div>
                </div>
                <div className='info'>
                  <div className='label'>학점</div>
                  <div className='content'>{`${finalDetail.gpa} / ${finalDetail.gpa_type}`}</div>
                </div>
              </div>

              <div className='divider' style={{ width: '1px', height: '64px', border: '1px solid white' }} />

              <div className='infos second'>
                <div className='info'>
                  <div className='label'>인턴 경력</div>
                  <div className='content end'>{finalDetail.num_of_intern}회</div>
                </div>
                <div className='info'>
                  <div className='label'>경력</div>
                  <div className='content end'>{finalDetail.num_of_career}회</div>
                </div>
              </div>
            </div>
          </StyledDetailInfo>
        </StyledInfos>
      </StyledInfoCard>

      <StyledInterviews>
        <article className='interviews'>
          <h2 className='interviewTitle'>기본질문</h2>
          <div className='interviewQuestion'>
            <div className='tagBox'>
              <QuestionTag>질문 1</QuestionTag>
            </div>
            <div className='interviewContent'>
              <div className='title'>본인만의 합격이유와 인터뷰 Tip을 알려주세요</div>
              <div className='content'>{finalDetail.pass_tip}</div>
            </div>
          </div>
          <div className='interviewQuestion'>
            <div className='tagBox'>
              <QuestionTag>질문 2</QuestionTag>
            </div>
            <div className='interviewContent'>
              <div className='title'>본인만의 케이스 공부법을 알려주세요</div>
              <div className='content'>{finalDetail.case_study}</div>
            </div>
          </div>
          <div className='interviewQuestion'>
            <div className='tagBox'>
              <QuestionTag>질문 3</QuestionTag>
            </div>
            <div className='interviewContent'>
              <div className='title'>취업준비에 가장 도움되었던 활동 및 경험을 공유해주세요</div>
              <div className='content'>{finalDetail.experience_for_career}</div>
            </div>
          </div>
        </article>
      </StyledInterviews>

      <StyledInterviews>
        <article className='interviews'>
          <h2 className='interviewTitle'>채용 프로세스</h2>
          {finalDetail.interview_review_tip.map(({ interview_type, body_for_pass_interview }: any) => {
            if (interview_type === 'cv') {
              return (
                <div className='interviewQuestion'>
                  <div className='tagBox'>
                    <GuideTag>
                      서류 <div className='icon' />
                    </GuideTag>
                  </div>
                  <div className='interviewContent'>
                    <div className='content'>{body_for_pass_interview}</div>
                  </div>
                </div>
              );
            }

            if (interview_type === 'online') {
              return (
                <div className='interviewQuestion'>
                  <div className='tagBox'>
                    <GuideTag>
                      온라인 테스트 <div className='icon' />
                    </GuideTag>
                  </div>
                  <div className='interviewContent'>
                    <div className='content'>{body_for_pass_interview}</div>
                  </div>
                </div>
              );
            }

            if (interview_type === 'pt') {
              return (
                <div className='interviewQuestion'>
                  <div className='tagBox'>
                    <GuideTag>
                      PT <div className='icon' />
                    </GuideTag>
                  </div>
                  <div className='interviewContent'>
                    <div className='content'>{body_for_pass_interview}</div>
                  </div>
                </div>
              );
            }
          })}
        </article>

        {currentUser ? (
          finalDetail.interview_review.map((interview: any, i) => (
            <div className='interviewQuestion'>
              <div className='tagBox'>
                <GuideTag>
                  {i + 1}차 인터뷰 <div className='icon second' />
                </GuideTag>
              </div>
              <InterviewDetail
                problemSolving={interview.problem_solving}
                data={{
                  interview_progress: interview.interview_progress,
                  interview_atmosphere: interview.interview_atmosphere,
                  interview_level: interview.interview_level,
                  interview_pass: 'pass',
                  fit_importance: interview.fit_importance,
                  case_importance: interview.case_importance,
                  questions: [interview.questions[0].question, interview.questions[1].question],
                }}
              />
            </div>
          ))
        ) : (
          <div className='interviewQuestion LoginModal'>
            <div className='tagBox'>
              <GuideTag>
                1차 인터뷰 <div className='icon second' />
              </GuideTag>
            </div>
            <div style={{ position: 'relative' }}>
              <img src={blurPage} alt='' style={{ width: '100%' }} />
              <LoginModal>
                <h1>로그인</h1>
                <p>로그인을 통해 최근 합격자들의 인터뷰 노하우와 그들만의 케이스 풀이법을 확인해보세요</p>
                <div className='btns'>
                  <Link to={`${ERoute.UserSignup}?next=${ERoute.FinalAcceptanceDetail.replace(':id', id)}`}>
                    <Button>회원가입</Button>
                  </Link>
                  <Link to={`${ERoute.UserLogin}?next=${ERoute.FinalAcceptanceDetail.replace(':id', id)}`}>
                    <Button type='primary'>로그인</Button>
                  </Link>
                </div>
              </LoginModal>
            </div>
          </div>
        )}
      </StyledInterviews>

      <StyledBottomBtns>
        <Link to={'/community/final_acceptance'}>
          <Button>목록보기</Button>
        </Link>
        <Link to={'/community/final_acceptance/write'}>
          <Button type='primary'>최종합격 후기 등록</Button>
        </Link>
      </StyledBottomBtns>
    </StyledContainer>
  );
};

export default FinalAcceptanceDetail;

const StyledContainer = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: ${CWindowWidth - 300}px;
  margin: 150px auto 0 auto;
  padding: 0 50px;
  word-break: keep-all;

  @media screen and ${device.lg} {
    padding: 0 20px;
  }
`;

const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e4e4;

  @media screen and ${device.lg} {
    flex-direction: column;
    align-items: flex-start;
  }

  .title {
    font-size: 24px;
    font-weight: 900;
    color: ${PrimaryColor};
  }

  .btns {
    @media screen and ${device.lg} {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 8px;
    }
  }

  .ant-btn {
    &:first-child {
      margin-right: 12px;
    }
  }
`;

const StyledInfoCard = styled.div`
  display: flex;
  width: 100%;
  margin-top: 30px;
  padding: 28px 32px 30px 25px;
  border: 1px solid #e4e4e4;
  border-radius: 10px;

  .img {
    width: 62px;
    height: 62px;
    margin-right: 15px;
    background-color: black;

    @media screen and ${device.lg} {
      display: none;
    }
  }
`;

const StyledInfos = styled.div`
  width: 100%;

  .infoHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .company {
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: 700;

    @media screen and ${device.lg} {
      font-size: 20px;
    }
  }

  .subtitles {
    display: flex;
    align-items: center;

    h3 {
      margin: 0;
      font-size: 18px;
      line-height: 1;
      color: #14112a;

      @media screen and ${device.lg} {
        font-size: 14px;
      }
    }
  }

  .employmentType {
    padding-right: 10px;
    border-right: 1px solid #aeaeae;
  }

  .employmentDate {
    padding-left: 10px;
  }
`;

const StyledDetailInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 26px;
  padding: 21px 30px;
  background-color: #f9f9f9;
  border-radius: 10px;

  @media screen and ${device.lg} {
    justify-content: center;
  }

  .avatar {
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and ${device.lg} {
      margin-top: 15px;
    }

    .avatarIcon {
      width: 44px;
      height: 44px;
    }

    .avatarText {
      width: 70px;
      margin-top: 5px;
      font-size: 14px;
      font-weight: 100;
      color: ${SecondaryColor};
    }
  }

  .divider {
    @media screen and ${device.lg} {
      display: none;
    }
  }

  .infosBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media screen and ${device.lg} {
      flex-direction: column;
      width: auto;
      margin-left: 35px;
    }
  }

  .schoolLogo {
    @media screen and ${device.lg} {
      display: none;
    }
  }

  .infos {
    display: flex;

    @media screen and ${device.lg} {
      flex-direction: column;
    }
  }

  .infos.first {
    /* padding: 0 43px; */
    /* border-left: 2px solid #ffffff;
    border-right: 2px solid #ffffff; */

    @media screen and ${device.lg} {
      padding: 0%;
      border: none;
    }
  }

  .infos.second {
    /* margin-left: 20px; */

    @media screen and ${device.lg} {
      margin: 0;
      width: 100%;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 25px;

    @media screen and ${device.lg} {
      margin: 15px 0;
    }
  }

  .label {
    margin-bottom: 3px;
    color: #aeaeae;
  }

  .content {
    font-size: 18px;
  }

  .content.end {
    width: 60px;
    text-align: end;
  }
`;

const StyledInterviews = styled.section`
  width: 100%;
  margin-top: 30px;

  .interviews {
    padding-top: 20px;
    border-top: 1px solid #e4e4e4;
  }

  .interviewTitle {
    margin-bottom: 40px;
    font-size: 20px;
    font-weight: 700;
    color: ${SecondaryColor};
  }

  .interviewQuestion {
    display: flex;

    @media screen and ${device.lg} {
      flex-direction: column;
    }
  }

  .interviewContent {
    .title {
      margin-bottom: 10px;
      font-size: 24px;
      color: ${PrimaryColor};
    }

    .content {
      margin-bottom: 40px;
      font-size: 16px;
      line-height: 30px;
    }
  }

  .tagBox {
    display: flex;
    justify-content: flex-end;
    min-width: 180px;

    @media screen and ${device.lg} {
      justify-content: flex-start;
      margin-bottom: 10px;
    }
  }
`;

const QuestionTag = styled.div`
  margin-right: 18px;
  width: 72px;
  height: 35px;
  padding: 6px 10px;
  border: 1px solid ${PrimaryColor};
  border-radius: 20px;
  color: ${PrimaryColor};
  text-align: center;
`;

const GuideTag = styled.div`
  display: flex;
  align-items: center;
  max-height: 35px;
  margin-right: 32px;
  font-size: 20px;

  .icon {
    width: 19px;
    height: 19px;
    margin-left: 10px;
    border-radius: 50%;
    background-color: #b1dfb3;
  }

  .icon.second {
    background-color: #6abc6d;
  }
`;

const StyledBottomBtns = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 100px;
  padding-top: 10px;
  border-top: 1px solid #e4e4e4;

  button.ant-btn {
    height: auto;
    padding: 8px 12px !important;
  }
`;

const LoginModal = styled.div`
  position: absolute;
  top: 30%;
  left: 50%;
  width: 350px;
  padding: 30px;
  border-radius: 8px;
  background-color: #ffffff;
  transform: translate(-50%, -50%);

  @media screen and ${device.lg} {
  }

  h1 {
    font-size: 32px;
  }

  p {
    margin-bottom: 30px;
  }

  .btns {
    display: flex;
    justify-content: space-between;
  }
`;
